<template>
  <el-dialog
    title="责任人选择"
    :visible.sync="dialogVisible"
    width="480px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-input
        v-model="personName"
        clearable
        placeholder="请输入人员名称"
        style="width:428px;"
      >
        <el-button
          style=" background: #0495FF;
                          border-radius: 0px 4px 4px 0px;
                          color: #FFFFFF;"
          slot="append"
          icon="el-icon-search"
          @click.stop="search"
        ></el-button>
      </el-input>
      <el-radio-group v-model="userId">
        <el-radio
          v-for="(item, index) in radioList"
          :key="index"
          :label="item.personId"
          >{{ item.personName }}</el-radio
        >
      </el-radio-group>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getPointPersonListPage } from "@/api/point.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    pointId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      personName: "",
      userId: "",
      radioList: [],
      radioAllList: []
    };
  },
  mounted() {
    this.getPointPersonListPageFun();
  },
  methods: {
    search() {
      if (!this.personName) {
        this.radioList = this.radioAllList;
      } else {
        this.radioList = this.radioAllList.filter(
          item => item.personName.indexOf(this.personName) > -1
        );
      }
    },
    removeDuplicatesById(arrObj) {
      let map = new Map();
      for (let item of arrObj) {
        if (!map.has(item.personId)) {
          map.set(item.personId, item);
        }
      }
      return [...map.values()];
    },
    // 分页查询
    async getPointPersonListPageFun() {
      let params = {
        pointId: this.pointId,
        page: 1,
        size: 9999
      };
      const res = await getPointPersonListPage(params);
      if (res.data.code == 200) {
        let arr = this.removeDuplicatesById(
          res.data.data.records ? res.data.data.records : []
        );
        this.radioAllList = JSON.parse(JSON.stringify(arr));
        this.radioList = JSON.parse(JSON.stringify(arr));
      }
    },
    save() {
      this.handleClose();
      if (!this.userId) return;
      let item = this.radioList.find(item => item.personId == this.userId);
      this.$emit("updateData", {
        userId: this.userId,
        userName: item.personName
      });
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}
/deep/.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  .el-radio {
    width: 20%;
    display: flex;
    align-items: center;
    margin-bottom: 28px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/task/longInspectionTask/components/personDialog.vue